module.exports = __webpack_public_path__ + "media/images/angle-down-c1b647e725a46a6a408dfa3feccd8b7d.svg";